import React, { Component } from 'react';
import './Fields.css'
import Slim from './slim/slim.react';
import cog from '../static/vectors/cog.svg';
import Api from '../services/api';
import AuthService from '../services/auth';
import Modal from 'react-modal';
import checkCircle from '../static/vectors/check-circle.svg';

class ProfilePhotos extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        photos: [],
        deletedPhotos: [],
      },
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
      uploadedPhoto: '',
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        let { photos } = response.user;
        photos = photos.map(photo => {
          return {
            photo: photo.photoUrl,
            profile: !!photo.profile,
            id: photo.id,
            open: false,
          }
        });
        this.setState({
          fields: {
            photos,
            deletedPhotos: [],
          },
          id: response.user.id,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    let { fields, id } = this.state;

    this.setState({
      canSubmit: false,
    }, () => {
      (new Api()).put(`/users/${id}`, fields, AuthService.getAuthCookie())
        .then(response => {
          let { photos } = response.user;
          photos = photos.map(photo => {
            return {
              photo: photo.photoUrl,
              profile: !!photo.profile,
              id: photo.id,
              open: false,
            }
          });
          this.setState({
            fields: {
              photos,
              deletedPhotos: [],
            },
            id: response.user.id,
            isModalOpen: true,
            modalMessage: response.message,
            canSubmit: false,
          });
        });
    });
  }

  handleUpload(file){
    this.getBase64(file);
    return true;
  }

  getBase64(file) {
    const reader = new FileReader();
    let component = this;

    reader.readAsDataURL(file);
    reader.onload = () => {
      component.setState({
        uploadedPhoto: reader.result,
      });
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
  }

  handleBase64(formdata, progress, success, failure, slim) {
    let fields = this.state.fields;
    const { uploadedPhoto } = this.state;
    fields.photos.push({
        photo: slim.dataBase64.output.image,
        originalPhoto: uploadedPhoto,
        profile: false,
        id: 'new',
        open: false,
      });
    this.setState({ uploadedPhoto: '', fields, canSubmit: true, }, () => {success("upload done");slim.remove()});
  }

  setPrimaryPhoto(e, i){
    e.preventDefault();
    let { fields } = this.state;
    fields.photos.map(photo => {
      photo.profile = false;
      return photo;
    });

    fields.photos[i].profile = true;
    this.setState({ fields, canSubmit: true, });
  }

  deletePhoto(e, i){
    e.preventDefault();
    let { fields } = this.state;

    const deletedId = fields.photos[i].id;

    if(deletedId !== 'new') {
      fields.deletedPhotos.push(deletedId);
    }

    const wasProfile = fields.photos[i].profile;

    fields.photos.splice(i,1);

    if(wasProfile) {
      fields.photos[0].profile = true;
    }

    this.setState({ fields, canSubmit: true, });

  }

  toggleSubMenu(e, i){
    e.preventDefault();
    let { fields } = this.state;

    fields.photos[i].open = !fields.photos[i].open;

    this.setState({ fields });

  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { fields, isModalOpen, modalMessage, canSubmit  } = this.state;
    const { title } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="row photos">
          {fields.photos.map((photo, i) => {
            return (
              <div key={Math.random()} className="col col-6 col-md-3">
                <div className="photo" style={{
                  backgroundImage: `url(${photo.photo})`,
                }}>
                  <div className="settings-bar">
                    <span>{photo.profile && 'Profile'}</span>
                    <img
                      onClick={(e) => {this.toggleSubMenu(e, i)}}
                      src={cog}
                      alt="Settings"
                    />
                    <div className={`sub-menu ${(photo.open)?'open':''}`}>
                      {!photo.profile && <button onClick={(e) => {this.setPrimaryPhoto(e, i)}} className="sub-menu-link">Mark as primary</button>}
                      {fields.photos.length > 1 && <button onClick={(e) => {this.deletePhoto(e, i)}} className="sub-menu-link">Delete photo</button>}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
          </div>
          {fields.photos.length < 3 && <p>Please make photos larger than 400px x 400px and make sure you are in the photo. Don't place photos displaying nudity. Photos can take up to 48 hours to be reviewed before they get added to your profile, once uploaded.</p>}
          {fields.photos.length < 3 && <div className="field-container image">
          <div className="row">
            <div className="col">
              <Slim ratio="1:1"
                    minSize={ { width:400, height:400 } }
                    uploadBase64="true"
                    jpegCompression={70}
                    instantEdit="true"
                    didLoad={this.handleUpload.bind(this)}
                    push="true"
                    post={['input', 'output', 'actions']}
                    label="Add photos"
                    service={ this.handleBase64.bind(this) }
              >
              </Slim>
            </div>
          </div>
        </div>}
        </form>
        <button
          className="submit btn"
          disabled={!canSubmit}
          onClick={(e) => {this.handleSubmit(e);}}
        >
          Save profile
        </button>
        <Modal
        isOpen={isModalOpen}
        onRequestClose={() => {this.closeModal()}}
        contentLabel="Example Modal"
        style={{
          content: {
            top: '50%',
            bottom: 'auto',
            left: '50%',
            right: 'auto',
            transform: 'translate(-50%, -50%)',
          }
        }}
      >
        <div className="content text-center">
          <img src={checkCircle} alt="check" />
          <div className="message">{modalMessage}</div>
          <button onClick={() => {this.closeModal()}}> Close X</button>
        </div>
      </Modal>
      </div>
    )
  }
}

export default ProfilePhotos;


// WEBPACK FOOTER //
// ./src/components/ProfilePhotos.js